









import { Component, Vue } from "vue-property-decorator"
import CandidateDashboardShareCode from "./CandidateDashboardShareCode.vue"

@Component({
  components: {
    CandidateDashboardShareCode,
  },
})
export default class CandidateDashboardGetStarted extends Vue {
  handleComplete(questionnaire) {
    this.$emit("complete", questionnaire)
  }
}
